import { render, staticRenderFns } from "./DonutChart31.vue?vue&type=template&id=50661cae&scoped=true&"
import script from "./DonutChart31.vue?vue&type=script&lang=js&"
export * from "./DonutChart31.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50661cae",
  null
  
)

export default component.exports